import styled, { keyframes } from "styled-components";
import { theme } from "../../constants/theme";

const heartbeat = keyframes`
  0%, 90%, 100% { transform: scale(1); }
  45%           { transform: scale(1.18); }
  55%           { transform: scale(0.95); }
  70%           { transform: scale(1.08); }
`;

export const StyledFooter = styled.footer`
  background-color: ${theme.color.bg};
  border-top: 1px solid ${theme.color.border};
  padding: 2.25rem 0 !important;
  font-family: ${theme.font.body};
  color: ${theme.color.textMuted};

  .footer-nav {
    width: 100%;
    min-width: 0;
  }

  .footer-nav ul {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem 1.25rem;
    padding: 0;
    margin: 0;
    list-style: none;
    align-items: center;
  }

  .footer-nav li {
    padding: 0;
  }

  /* Paper Kit's higher-specificity .footer.footer-black rules otherwise
     replace these links with 12px #777 text at 80% opacity (2.91:1 on this
     surface). Duplicate the component selector so the design tokens remain
     authoritative without using !important. */
  && .footer-nav a {
    font-size: 0.9rem;
    font-weight: ${theme.weight.medium};
    color: ${theme.color.textMuted};
    opacity: 1;
    transition: color ${theme.motion.base};

    &:hover {
      color: ${theme.color.slate};
    }
  }

  .footer-nav li:last-child,
  .footer-nav li:last-child a {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  && .credits {
    width: 100%;
    margin-top: 1.25rem;
    text-align: right;
    font-size: 0.875rem;
    color: ${theme.color.textMuted};
    opacity: 1;
  }

  && .copyright {
    color: ${theme.color.textMuted};
    opacity: 1;
  }

  .heart {
    color: ${theme.color.salmonDeep};
    display: inline-block;
    margin: 0 0.15rem;
    animation: ${heartbeat} 2.4s ease-in-out infinite;
  }

  @media (max-width: 767px) {
    text-align: center;

    .footer-nav ul {
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .footer-nav { text-align: center; }

    .credits {
      width: 100%;
      text-align: center;
      margin-top: 0.75rem;
    }
  }
`;

export const CreditsFooter = styled.div`
  margin-left: auto;
`;

export const ColoredFooter = styled.footer``;

export const ContactSection = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;

  i.fa {
    color: ${theme.color.salmonDeep};
  }

  a {
    display: inline-block !important;
    color: ${theme.color.textMuted};
    transition: color ${theme.motion.base};

    &:hover {
      color: ${theme.color.slate};
    }
  }
`;
